const API_BASE_URL = 'http://localhost:5000/api'

class ProductRolesAPI {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`
    const token = localStorage.getItem('token')
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)
      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`)
      }

      return data
    } catch (error) {
      console.error(`API Error (${endpoint}):`, error)
      throw error
    }
  }

  // Get all product roles with pagination and search
  async getAllRoles(options = {}) {
    const { page = 1, limit = 10, search = '', product_id } = options
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(product_id && { product_id })
    })

    return this.request(`/product-roles?${params}`)
  }

  // Get role by ID
  async getRoleById(id) {
    return this.request(`/product-roles/${id}`)
  }

  // Get roles for a specific product
  async getRolesByProduct(productId) {
    return this.request(`/product-roles/organization/product/${productId}`)
  }

  // Get available permissions for a product
  async getAvailablePermissions(productId) {
    return this.request(`/product-roles/permissions/${productId}`)
  }

  // Create new product role
  async createRole(roleData) {
    return this.request('/product-roles', {
      method: 'POST',
      body: JSON.stringify(roleData)
    })
  }

  // Update product role
  async updateRole(id, roleData) {
    return this.request(`/product-roles/${id}`, {
      method: 'PUT',
      body: JSON.stringify(roleData)
    })
  }

  // Delete product role
  async deleteRole(id) {
    return this.request(`/product-roles/${id}`, {
      method: 'DELETE'
    })
  }
}

export default new ProductRolesAPI()


